// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from "../../../services/api";

const encodeEmailForUrl = (email) => {
  const [localPart, domain] = email.split("@");
  const encodedLocalPart = encodeURIComponent(localPart);
  if (!domain) {
    return encodedLocalPart;
  }
  return `${encodedLocalPart}@${domain}`;
};

const loginService = async (data) => {
  const cartId = data.cartId ? `&CartID=${data.cartId}` : "";
  const encodedEmail = encodeEmailForUrl(data.email);
  return api(
    `/Sellitback.svc/Login?EmailId=${encodedEmail}&Password=${data.password}${cartId}`,
    {},
    "GET"
  );
};

export default loginService;
